import React from "react";
import ConnectedField from "components/ConnectedField";
import { getFieldPath, integerTransformer } from "utils/form";
import classnames from "classnames";
import { TRIAL_PERIOD_DAYS } from "utils/constants/state";

const COPY = [
  "Set the default trial length in days for subscriptions to your products. If zero is used, then a trial period will not be set for new purchases on subscription based products, unless defined in the checkout terms.",
  "Once the trial expires, the card details on file for the purchasing customer will be charged for the first time."
];

const DEFAULT_CLASSES = {
  container: "flex flex-column flex-row-ns justify-between-ns",
  copyWrapper: "flex flex-column",
  fieldWrapper:
    "w-100 w-50-ns flex flex-row items-center justify-between justify-end-ns pt3 pt0-ns"
};

const TrialPeriodDays = ({ name, disabled, copy = COPY, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const trialPeriodDaysPath = getFieldPath(name, TRIAL_PERIOD_DAYS);

  return (
    <div className={classes.container}>
      <div className={classes.copyWrapper}>
        {copy.map((block, blockIx) => (
          <div
            key={blockIx}
            className={classnames("f5 lh-copy", {
              "pt2": blockIx,
              "o-80": disabled
            })}
          >
            {block}
          </div>
        ))}
      </div>
      <div className={classes.fieldWrapper}>
        <div className="flex flex-row items-center justify-end">
          <div className="w3">
            <ConnectedField
              disabled={disabled}
              name={trialPeriodDaysPath}
              transformer={integerTransformer}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialPeriodDays;
